(() => {
function $bdaa65c8cc66fe0a$var$accountNav() {
    jQuery(document).ready(function() {
        jQuery("body.woocommerce-account .nav-tab-wrapper a:last-child").attr("target", "_blank");
    });
}
$bdaa65c8cc66fe0a$var$accountNav();

})();
//# sourceMappingURL=main.js.map
